var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"button",class:{ alert: _vm.isSet() },domProps:{"textContent":_vm._s(_vm.label)},on:{"click":function($event){$event.preventDefault();return _vm.set.apply(null, arguments)}}})}
var staticRenderFns = []

export { render, staticRenderFns }